module.exports = __webpack_public_path__ + "static/media/down-arrow.985742ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/down-arrow.svg
// module id = 643
// module chunks = 0